import BaseModelRequest from '../communicate/BaseModelRequest'

export default class CartRequest extends BaseModelRequest{

  getModelName () {
    return "cart";
  }

  addItemIntoCart(item) {

  }

  verifyPromo(code) {
    const url = `order-item/promo/$code`;
    return this.post(url, '');
  }
}



// WEBPACK FOOTER //
// ./src/request/CartRequest.js